import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PageRelatedItemPreviewComponent } from './page-related-item-preview.component';
import {RouterModule} from "@angular/router";
import { createCustomElement } from "@angular/elements";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ReplaceTokensPipeArrayModule, SafePipeModule} from "@signature-it/ngx-generic/pipes";
import { NoImageDirectiveModuleGeneric } from "@signature-it/ngx-generic/directives";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        CarouselModule,
        ReplaceTokensPipeArrayModule,
        SafePipeModule,
        NoImageDirectiveModuleGeneric,
    ],
    declarations: [PageRelatedItemPreviewComponent],
    exports: [PageRelatedItemPreviewComponent]
})

export class PageRelatedItemPreviewModuleGeneric {
    constructor(private injector: Injector) {
            const EntityCarouselComp = createCustomElement(PageRelatedItemPreviewComponent, {injector});
            !customElements.get('ngx-page-related-item-preview') && customElements.define('ngx-page-related-item-preview', EntityCarouselComp);
    }
}
